import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import { EmpresaProvider } from './context/EmpresaContext';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <EmpresaProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </EmpresaProvider>
  </React.StrictMode>
);
